<input
  #input
  matInput
  [matTooltip]="'GENERAL.PLEASE_SELECT_COUNTRY' | translate"
  [tabIndex]="tabIndex"
  [formControl]="inputCtrl"
  [matAutocomplete]="auto"
  [matTooltipDisabled]="!!this.country"
  [readonly]="!this.country"
  (blur)="onBlur()">
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayName"
  [autoActiveFirstOption]="true"
  (optionSelected)="onSelect($event)"
  (closed)="onClosed()">
  <ng-container *ngIf="this.seaPorts">
    <mat-option *ngFor="let seaPort of seaPorts" [value]="seaPort">{{ seaPort.name }}
      <span *ngIf="seaPort.code">-</span>
      <span class="text-hint"> {{ seaPort.code }}</span>
    </mat-option>
  </ng-container>
</mat-autocomplete>
<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>
